import styled from 'styled-components';
import {dropsYellow, primaryColor} from '../../constants/colors';
import {Badge} from './Badge';

export const DropBadge = styled(Badge)`
  color: ${primaryColor};
  background-color: ${dropsYellow};
  height: 22px;
  border-radius: 2px;
  font-size: 11px;
  font-weight: 700;
`;
